export default "/images/4c7e0c675c843437f04d192a31870210.avif";